<div class="loading" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<ng-container *ngIf="!isLoading">

    <app-socio-emotional-skills-test-welcome 
        *ngIf="!started"
        [test]="test"
        (start)="onStartTest()">
    </app-socio-emotional-skills-test-welcome>

    <app-socio-emotional-skills-test-question-runner 
        *ngIf="started" 
        [test]="test" 
        (finished)="onFinishTest($event)">
    </app-socio-emotional-skills-test-question-runner>

</ng-container>